import { Calendar } from "@ui/calendar";
import React, { useRef, useState } from "react";
import { enUS, arSA, Locale } from "date-fns/locale";

import { buttonVariants } from "@ui/button";
import { cn } from "@utils/lib/utils";

interface BasicCalenderProps {
  lang?: "ar" | "en";
  selectedDates: Date[];
  showOutsideDays?: boolean;
  fromYear?: number;
  toYear?: number;
  fromMonth?: Date;
  toMonth?: Date;
  onMonthChange?: (month: Date) => void;
}
export const BasicCalender = ({
  lang = "ar",
  selectedDates = [],
  showOutsideDays = false,
  fromYear,
  toYear,
  fromMonth,
  toMonth,
  onMonthChange,
}: BasicCalenderProps) => {
  const locale: Locale = lang == "ar" ? arSA : enUS;
  const currentYear = useRef<number>(new Date().getFullYear());
  const currentMonth = useRef<Date>(new Date());

  return (
    <Calendar
      locale={locale}
      showOutsideDays={showOutsideDays}
      mode="multiple"
      selected={selectedDates}
      fromYear={fromYear || 2020}
      toYear={currentYear.current || toYear}
      toMonth={new Date()}
      className="w-[560px] rounded-md bg-white dark:bg-[#1C1C1C] dark:text-white"
      modifiersClassNames={{
        today: "font-[700]",
      }}
      onMonthChange={(month) => {
        onMonthChange && onMonthChange(month);
      }}
      classNames={{
        nav_button: "outline-none bg-transparent hover:opacity-100",
        head_cell: "mx-5 w-9",
        head_row: "w-full flex pt-3",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-transparent [&:has([aria-selected])]:bg-transparent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20 mx-5 text-white [&:has([aria-selected].day-outside)]:bg-[#fbbf28]",
        month: "divide-y dark:divide-[#4A4A4A] space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100 rounded-full hover:bg-[#c9c9ca] hover:text-white font-medium cursor-auto bg-[#c9c9ca] rounded-full dark:bg-[#3C3B40]"
        ),
        day_selected:
          "rounded-full !bg-[#fbbf28] hover:!bg-[#fbbf28] font-medium !text-black",
      }}
    />
  );
};
